import { render, staticRenderFns } from "./HbBenefit.vue?vue&type=template&id=0af8cd12&scoped=true&"
import script from "./HbBenefit.vue?vue&type=script&lang=js&"
export * from "./HbBenefit.vue?vue&type=script&lang=js&"
import style0 from "./HbBenefit.vue?vue&type=style&index=0&id=0af8cd12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af8cd12",
  null
  
)

export default component.exports